/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n1CardBody.vue?vue&type=template&id=40c306ad&scoped=true&"
import script from "./n1CardBody.vue?vue&type=script&lang=js&"
export * from "./n1CardBody.vue?vue&type=script&lang=js&"
import style0 from "./n1CardBody.vue?vue&type=style&index=0&id=40c306ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c306ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
